/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { green, red } from '@material-ui/core/colors';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import {
  IoTrophySharp,
} from 'react-icons/io5';
import Avatar from '@material-ui/core/Avatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Tooltip from '@material-ui/core/Tooltip';
import IconEdit from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import { PersonPin } from '@material-ui/icons';
import { Loading } from './styles';
import { useStyles } from '../../constants/styles';

interface Props {
  id: string;
  nome?: string;
  description?: string;
  url?: string;
  submit?: Function;
  setDisabled: any;
  disabled: boolean;
  isActive?: boolean;
  setDataToPage?: any;
  type?: string;
  action?: any;
  loading?: boolean;
  idSelected?: string;
  activeOrInative: any;
  setOpen?: any;
}

const ItemsList: React.FC<Props> = ({
  id,
  description,
  nome,
  url,
  submit,
  disabled,
  isActive,
  action,
  type,
  loading,
  idSelected,
  activeOrInative,
  setOpen,
}) => {
  const classes = useStyles();

  const PurpleSwitch = withStyles({
    switchBase: {
      color: red[400],
      '&$checked': {
        color: green[500],
      },
      '&$checked + $track': {
        backgroundColor: green[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);

  return (
    <List key={id} className={classes.root}>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alt="Remy Sharp" src={url} />
        </ListItemAvatar>
        <ListItemText
          primary={nome}
          secondary={(
            <>
              {description}
            </>
          )}
        />
        {loading && idSelected === id ? (
          <div style={{ marginTop: 10, marginRight: 10 }}>
            <Loading size={24} />
          </div>
        ) : null}
        {!loading
          ? (
            <ListItemSecondaryAction>
              {!disabled && (
                <>
                  {type === 'rules' && (
                  <>
                    <Tooltip title="VISUALIZAR" placement="left">
                      <IconButton onClick={() => (submit ? submit() : null)}>
                        <IconEdit />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={isActive ? 'ATIVO' : 'INATIVO'} placement="bottom">
                      {/* @ts-ignore */}
                      <PurpleSwitch
                        checked={isActive}
                        onChange={async () => {
                          await activeOrInative();
                        }}
                        name="checkedA"
                      />
                    </Tooltip>
                  </>
                  )}
                  {type === 'ranking' && (
                    <>
                      <Tooltip title="VISUALIZAR" placement="left">
                        <IconButton onClick={() => (submit ? submit() : null)}>
                          <IoTrophySharp size={20} />
                        </IconButton>
                      </Tooltip>
                      {/* <Tooltip title={isActive ? 'ATIVO' : 'INATIVO'} placement="bottom">
                        <PurpleSwitch
                          checked={isActive}
                          onChange={async () => {
                            await activeOrInative();
                          }}
                          name="checkedA"
                        />
                      </Tooltip> */}
                    </>
                  )}
                  {type === 'poleposition' && (
                  <>
                    <Tooltip title={isActive ? 'ATIVO' : 'INATIVO'} placement="bottom">
                      {/* @ts-ignore */}
                      <PurpleSwitch
                        checked={isActive}
                        onChange={async () => {
                          if (type === 'poleposition') {
                            action();
                          } else {
                            await activeOrInative();
                          }
                        }}
                        name="checkedA"
                      />
                    </Tooltip>
                    <Tooltip title="EDITAR" placement="left">
                      <IconButton onClick={() => (submit ? submit() : null)}>
                        <IconEdit />
                      </IconButton>
                    </Tooltip>
                    {
                      setOpen !== undefined && (
                        <Tooltip title="CORRETORES" placement="left">
                          <IconButton onClick={() => {
                            if (setOpen !== undefined) {
                              setOpen();
                            }
                          }}
                          >
                            <PersonPin color="primary" />
                          </IconButton>
                        </Tooltip>
                      )
                    }
                  </>
                  )}
                </>
              )}
            </ListItemSecondaryAction>
          )
          : null}
      </ListItem>
      <Divider variant="inset" component="li" />
    </List>
  );
};

export default ItemsList;
